import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import moment from 'moment';

@Component({
    selector: 'app-confirm-dialog-suspend',
    templateUrl: './confirm-dialog-suspend.component.html',
    styleUrls: ['./confirm-dialog-suspend.component.scss'],
})
export class ConfirmDialogSuspendComponent implements OnInit {
    form: FormGroup;
    title: string;
    name: string;
    reasonId: number;
    reasons: any[];
    dateFieldName: string;
    hasReason: boolean;
    readingMode: boolean;
    clicked = false;
    icon;
    confirmButtons: boolean;
    constructor(
      public dialog: MatDialogRef<ConfirmDialogSuspendComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public toastr: ToastrService,
      private formBuilder: FormBuilder,) {
        this.title = data.title;
        this.hasReason = data.hasReason;
        this.dateFieldName = data.dateFieldName;
        this.name = data.name ? data.name : '';
        this.reasons = data.reasons ? data.reasons : [];
        this.icon = data.icon || 'error';
        this.readingMode = data.reading ? data.reading : false;
        this.confirmButtons = data.confirmButtons ?? true;
        const defaultData = data.defaultData? data.defaultData :{comment: "", operationDate: new Date(), reasonId: 0};
        this.form = this.formBuilder.group({
          comment:  new FormControl({value: defaultData.comment, disabled: this.readingMode || !this.hasReason}, Validators.required),
          reasonId: new FormControl({value: defaultData.reasonId, disabled: this.readingMode || !this.hasReason}, Validators.required),
          operationDate: new FormControl({value: new Date (defaultData.operationDate), disabled: this.readingMode}, Validators.required)
        });
        this.dialog.addPanelClass(data.class);
    }

    ngOnInit(): void {}

    close() {
        this.dialog.close(null);
    }
    reject() {
        this.dialog.close(false);
    }

    confirm() {
        this.clicked = true;
        const isValid = this.form.valid;
        if (isValid || this.readingMode)
        {
          this.dialog.close(this.form.value);
        }
        else {
          this.toastr.error('Favor de llenar campos faltantes');
        }

    }
}
